import React, { useEffect } from "react";
import TermsAndPolicy from "../../components/termsAndPolicy/termsAndPolicy";
import { PrivacyData } from "./content";

function PrivacyPolicyPage() {
  const Title = "Privacy Policy";
  const Intro =
    "This privacy policy is in place to ensure that your personal information is only used for internal purposes.";
  const Quote =
    "We are focused on leading our business as per these standards with a specific end goal to guarantee that the privacy of individual data is secure and maintained.";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <TermsAndPolicy
        title={Title}
        intro={Intro}
        content={PrivacyData}
        quote={Quote}
        type="policy"
      />
    </div>
  );
}

export default PrivacyPolicyPage;
